import { Types, ISearch, SearchAction } from '../types/types';

const initialState = {
    data: [],
    value: ''
}

export const searchReducer = ( state: Partial<ISearch> = initialState, action: SearchAction) => {
    switch (action.type) {
        case Types.arraySearch:
            return {
                ...state,
                data: [ ...action.payload ]
            }

        case Types.valueSearched:
            return {
                ...state,
                value: action.payload
            }
    
        default:
            return state;
    }
}